import { Tabs, Tab, Box, Collapse } from "@mui/material";
import { useState, useContext } from "react";
import { LeftPanelVisibleContext } from "../../contexts/LeftPanelVisibleContext";
import { LeftPanelContext } from "../../contexts/LeftPanelContext";
import Explore from "../panels/Explore";
import Evaluate from "../panels/Evaluate";
import NewPrioritize from "../panels/NewPrioritize";
import { trackEvent } from "../../hooks/useAnalytics";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { leftVisible, setLeftVis } = useContext(LeftPanelVisibleContext);
	const { children, value, index, ...other } = props;

	return (
		<Collapse
			in={leftVisible}
			className="left-panel__container"
		>
			<Box
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && (
					<Box
						className="left-panel__inner"
						sx={{
							visible: leftVisible,
						}}
					>
						{children}
					</Box>
				)}
			</Box>
		</Collapse>
	);
}

export default function TPLMenuBar() {
	const { leftVisible, setLeftVis } = useContext(LeftPanelVisibleContext);
	const { left, setLeft } = useContext(LeftPanelContext);
	const [value, setValue] = useState(0);
	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		if (newValue == 0) {
			setLeft("explore");
		}
		if (newValue == 1) {
			setLeft("prioritize");
		}
		if (newValue == 2) {
			setLeft("evaluate");
		}

		trackEvent("left_panel", newValue);
		//trackLeftPanelTabs(newValue);
		setValue(newValue);
	};

	// The Tabs, Tab, and TabPanel components are used to control which content is displaying in the left panel.
	return (
		<div>
			<Tabs
				value={value}
				onChange={handleChange}
				aria-label="basic tabs example"
				sx={{ width: "100%" }}
			>
				<Tab
					className="tabby"
					sx={{ color: "#f7931e", overflowY: "hidden" }}
					label="Explore"
					onClick={() => {
						value == 0 ? setLeftVis(!leftVisible) : setLeftVis(true);
					}}
				/>
				<Tab
					sx={{ color: "#f7931e" }}
					label="Prioritize"
					onClick={() => {
						value == 1 ? setLeftVis(!leftVisible) : setLeftVis(true);
					}}
				/>
				<Tab
					sx={{ color: "#f7931e" }}
					label="Evaluate"
					onClick={() => {
						value == 2 ? setLeftVis(!leftVisible) : setLeftVis(true);
					}}
				/>
			</Tabs>
			<TabPanel
				value={value}
				index={0}
			>
				<Explore />
			</TabPanel>
			<TabPanel
				value={value}
				index={1}
			>
				<NewPrioritize />
			</TabPanel>
			<TabPanel
				value={value}
				index={2}
			>
				<Evaluate />
			</TabPanel>
		</div>
	);
}
